/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {KTSVG} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'
import {getCSS} from '../../../assets/ts/_utils'
import moment from 'moment'
import {AllMessages, formatter, useLocalStorage} from '../../../../app/utils'
import {ChartRevenueModel} from '../../../../app/pages/dashboard/components/SummaryHealthInsurances'
import { Lang } from '../../../../app/modules/auth/apis'

type Props = {
  className: string
  dataChart: ChartRevenueModel
  handleFocusColumn: (data: any) => void
}

const ColumnLineChart: React.FC<Props> = ({className, dataChart, handleFocusColumn}) => {
  const [columnData, setColumnData] = useState<any>([])
  const [columnSelected, setColumnSelected] = useState('')
  const [lang] = useLocalStorage<Lang>('i18nConfig', {selectedLang: 'vi'})
  const chartRef = useRef<HTMLDivElement | null>(null)

  function handleClickChart(e: any, chart: any, options: any) {
    setColumnSelected(options.dataPointIndex)
  }

  useEffect(() => {
    handleFocusColumn(columnData[columnSelected])
  }, [columnSelected])

  function getChartOptions(height: number, label: any, data: any): ApexOptions {
    return {
      series: data,
      chart: {
        height: 350,
        type: 'line',
        id: 'test',
        fontFamily: 'Tahoma, sans-serif',
        // events: {
        //   click(e, chart, options) {
        //     handleClickChart(e, chart, options)
        //   },
        // },
        toolbar: {
          show: false,
        },
      },
      stroke: {
        width: [1, 2],
      },
      // title: {
      //   text: 'Biểu đồ doanh thu',
      // },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1],
      },
      xaxis: {
        type: 'category',
        categories: label,
        labels: {
          formatter: function (value) {
            return value
          },
        },
      },
      yaxis: [
        {
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: '#808080',
          },
          labels: {
            style: {
              colors: '#808080',
            },
            formatter: function (value) {
              return isNaN(value) ? value.toString() : formatter(value)
            },
          },
          title: {
            text: AllMessages[lang.selectedLang].DASHBOARD_DOANH_THU,
            style: {
              color: '#808080',
              fontWeight: '500',
            },
          },
          tooltip: {
            enabled: true,
          },
        },
        {
          seriesName: AllMessages[lang.selectedLang].SO_DON,
          opposite: true,
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: '#D2D711',
          },
          labels: {
            style: {
              colors: '#D2D711',
            },
          },
          title: {
            text: AllMessages[lang.selectedLang].SO_DON,
            style: {
              color: '#D2D711',
              fontWeight: '500',
            },
          },
        },
      ],
    }
  }

  function renderChart(data: ChartRevenueModel) {
    let series: any = []
    let seriesObj = {
      name: data.productName ? data.productName : 'Bảo hiểm con người',
      type: 'column',
      color: '#0096A9',
      data: data.dataRevenue,
    }
    series.push(seriesObj)
    series.push({
      name: AllMessages[lang.selectedLang].SO_DON,
      type: 'line',
      color: '#D2D711',
      data: data.dataContract,
    })

    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))
    const chart = new ApexCharts(chartRef.current, getChartOptions(height, data.dataDate, series))
    if (chartRef.current.childElementCount == 0 && chart) {
      chart.render()
    } else {
      ApexCharts.exec('test', 'updateSeries', series, true)
      ApexCharts.exec(
        'test',
        'updateOptions',
        {
          xaxis: {
            categories: data.dataDate,
          },
        },
        false,
        true
      )
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }

  useEffect(() => {
    if (dataChart.dataContract.length == 0) return
    renderChart(dataChart)
  }, [dataChart])

  return (
    <div>
      <div ref={chartRef} id='dashboard-column-line-chart' style={{height: '350px'}} />
    </div>
  )
}

export {ColumnLineChart}
